import { render, staticRenderFns } from "./VideoView.vue?vue&type=template&id=2e62a6bc&scoped=true&"
import script from "./VideoView.vue?vue&type=script&lang=js&"
export * from "./VideoView.vue?vue&type=script&lang=js&"
import style0 from "./VideoView.vue?vue&type=style&index=0&id=2e62a6bc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e62a6bc",
  null
  
)

export default component.exports